const rules = {
  MERCADO_PAGO: {
    MERCADO_PAGO_CHECKOUT_PRO: [
      'SELLER_CHECKOUT_PRO_ACCESS_TOKEN',
      'ENABLED_PAYMENT_METHODS',
      'GUEST_MODE',
    ],
    MERCADO_PAGO_CHECKOUT_PRO_WALLET_BUTTON: [
      'SELLER_CHECKOUT_PRO_ACCESS_TOKEN',
      'ENABLED_PAYMENT_METHODS',
      'GUEST_MODE',
    ],
    CARD: ['SELLER_CHECKOUT_PRO_ACCESS_TOKEN'],
    PSE: ['SELLER_CHECKOUT_PRO_ACCESS_TOKEN'],
    MERCADO_PAGO_WALLET: ['SELLER_CHECKOUT_PRO_ACCESS_TOKEN'],
  },
  STP: {
    CODI: [
      'CODI_COMPANY_ACCOUNT',
      'CODI_NAME_ACCOUNT',
      'CODI_BANK_ACCOUNT',
      'CODI_PRIVATE_KEY',
    ],
    SPEI: ['SPEI_COMPANY_ACCOUNT', 'SPEI_BANK_ACCOUNT', 'SPEI_PRIVATE_KEY'],
  },
  ARCUS: {
    CASH: ['PAYEE_ID'],
    SPEI: ['USER_NAME', 'PASSWORD', 'CUSTOMER_ID'],
  },
  CIELO: {
    CARD: ['MERCHANT_ID', 'MERCHANT_KEY'],
    APPLE_PAY: ['MERCHANT_ID', 'MERCHANT_KEY'],
    GOOGLE_PAY: ['MERCHANT_ID', 'MERCHANT_KEY'],
  },
  TRANSBANK: {
    CARD: [
      'COMPANY_REGISTERED_NAME',
      'COMPANY_TRADE_NAME',
      'MERCHANT_CODE',
      'TERMINAL_ID',
      'MCC',
      'RUT',
    ],
    WEBPAY: [
      'COMPANY_REGISTERED_NAME',
      'COMPANY_TRADE_NAME',
      'CLIENT_CODE',
      'MERCHANT_CODE',
      'TERMINAL_ID',
      'MCC',
      'RUT',
    ],
  },
  PAGSEGURO: {
    CARD: ['PS_CODE', 'MERCHANT_ID', 'MERCHANT_KEY', 'REDIRECT_URL'],
    CASH: ['STORE_ID', 'SECRET_KEY'],
    BANK_TRANSFER: ['STORE_ID', 'SECRET_KEY'],
  },
  TRANSBANK_2: {
    CARD: {
      'Transacción Completa Mall': ['API_KEY_MALL', 'API_KEY', 'SECRET_KEY'],
      'Transacción Completa': ['API_KEY', 'SECRET_KEY'],
    },
    WEBPAY_PLUS: ['API_KEY', 'SECRET_KEY'],
    WEBPAY_PLUS_MALL: ['API_KEY_MALL', 'API_KEY', 'SECRET_KEY'],
  },
  PAYMENTEZ: {
    WEBPAY: ['APPLICATION_CODE', 'SECRET_KEY'],
    PSE: ['APPLICATION_CODE', 'SECRET_KEY'],
    CASH: ['APPLICATION_CODE', 'SECRET_KEY'],
    OXXO: ['APPLICATION_CODE', 'SECRET_KEY'],
    PAGO_EFECTIVO: ['APPLICATION_CODE', 'SECRET_KEY'],
    CARD: ['APPLICATION_CODE', 'SECRET_KEY', 'EMAIL', 'PASSWORD'],
  },
}

const filterFields = (fields, availableRule) => {
  return fields.filter((field) => availableRule?.includes(field.param_id))
}

export const useConnectionFieldRules = ({
  fields,
  providerId,
  selectedMethod,
  integrationType,
}) => {
  if (integrationType && providerId !== 'MERCADO_PAGO') {
    const availableRuleIntegrationType =
      selectedMethod === 'CARD'
        ? rules?.[providerId]?.[selectedMethod]?.[integrationType]
        : rules?.[providerId]?.[selectedMethod]
    return {
      availableFields: filterFields(fields, availableRuleIntegrationType),
    }
  }

  if (
    ![
      'MERCADO_PAGO',
      'STP',
      'ARCUS',
      'TRANSBANK',
      'PAGSEGURO',
      'TRANSBANK_2',
      'PAYMENTEZ',
    ].includes(providerId)
  ) {
    return { availableFields: fields }
  }
  const availableRule = rules?.[providerId]?.[selectedMethod]

  if (!selectedMethod) {
    return { availableFields: [] }
  }

  if (!availableRule) {
    return { availableFields: fields }
  }

  return {
    availableFields: filterFields(fields, availableRule),
  }
}
